import { supabase } from '../supabaseClient';

const LIMITS = {
  add_run:            { max: 50,  window: 15 },
  sync_strava:        { max: 10,  window: 60 },
  fetch_activities:   { max: 100, window: 15 },
  update_profile:     { max: 20,  window: 60 },
  generate_race_plan: { max: 20,  window: 60 },
  auth_retry:         { max: 10,  window: 15 },
  import_gpx:         { max: 30,  window: 60 },
  waitlist_submit:    { max: 3,   window: 60 },
};

export async function checkLimit(endpoint) {
  if (!supabase) return;
  const limit = LIMITS[endpoint];
  if (!limit) return;

  const { data: allowed, error } = await supabase.rpc('check_rate_limit', {
    p_endpoint:       endpoint,
    p_max_requests:   limit.max,
    p_window_minutes: limit.window,
  });

  if (error) {
    console.error('[rateLimiter]', error);
    return;
  }

  if (!allowed) {
    const info = await getRemainingInfo(endpoint);
    const resetMin = info?.reset_at
      ? Math.ceil((new Date(info.reset_at) - new Date()) / 60000)
      : limit.window;
    throw new RateLimitError(
      `Trop de requêtes. Réessaie dans ${resetMin} minute${resetMin > 1 ? 's' : ''}.`,
      endpoint, resetMin
    );
  }
}

export async function getRemainingInfo(endpoint) {
  if (!supabase) return null;
  const limit = LIMITS[endpoint];
  if (!limit) return null;

  const { data, error } = await supabase.rpc('get_rate_limit_info', {
    p_endpoint: endpoint,
    p_max_requests: limit.max,
    p_window_minutes: limit.window,
  });

  if (error || !data || data.length === 0) return null;
  return data[0];
}

export class RateLimitError extends Error {
  constructor(message, endpoint, resetMin) {
    super(message);
    this.name = 'RateLimitError';
    this.endpoint = endpoint;
    this.resetMinutes = resetMin;
  }
}

export async function withRateLimit(endpoint, fn) {
  await checkLimit(endpoint);
  return await fn();
}
